<div class="node-editor" *ngIf="node && !node.deleted">
    <div class="operator" (click)="selectNode()">
        <div class="operator-layout">
            <div class="label">
                <div class="label-alignment">
                    <div class="rotation">
                        <sc-dictionary-label dictionaryKey="tmc-yard.entity.filter-tree-node.operator.{{node.operator}}"></sc-dictionary-label>
                    </div>
                </div>
            </div>
            <div class="actions">
                <button mat-flat-button class="delete-button" (click)="deleteNode()" *ngIf="node.parentNode != null">
                    <sc-icon iconClass="fa-trash"></sc-icon></button>
            </div>
        </div>
    </div>
    <div class="spacer-column"></div>
    <div class="conditions">
        <div class="conditions-list" (dragover)="onDragOverConditionsList($event)"
            (drop)="onDropOptionToConditionsList($event)" [ngClass]="{'highlight-dropzone' : conditionDropzoneActive}">
            <div class="condition" *ngFor="let condition of sortedConditions">
                <app-filter-condition [setfilterAdministrationContext]="filterAdministrationContext"
                    [setFilterCondition]="condition" *ngIf="!condition.deleted"></app-filter-condition>
            </div>
        </div>
        <div class="spacer-row"></div>
        <div class="nodes">
            <ng-container *ngFor="let node of node.nodes">
                <app-node-editor [setfilterAdministrationContext]="filterAdministrationContext" [setNode]="node">
                </app-node-editor>
                <div class="spacer-row"></div>
            </ng-container>
        </div>
        <div>
            <button mat-flat-button class="add-button" (click)="addChildNode()"><sc-icon iconClass="fa-plus"></sc-icon></button>
        </div>
    </div>
</div>
